import React from 'react';
import { connect } from 'react-redux';

import { 
    userGetPermission as userGetPermissionAction,
} from 'actions/authActions';


export class PermissionPlaceholder extends React.PureComponent {
    componentDidMount() {
        this.props.userGetPermission();
    }

    render() {
      return null;
    }
}

export default connect(null, {
    userGetPermission: userGetPermissionAction,
})(PermissionPlaceholder);



// WEBPACK FOOTER //
// ./src/auth/PermissionPlaceholder.js